import NextLink from 'next/link';

import { OwnerAvatar } from '@playbooks/components/owner/owner-avatar';
import { Icon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

import { formatDate } from 'utils';

const BlogGridCard = ({ article, featured = false, rootLink = '' }) => {
	// Theme
	const classNames = {
		root: cn(
			'group block h-full min-w-0 w-full overflow-hidden rounded-media border bg-surface text-left transition-colors hover:border-border-strong hover:bg-surface-hover',
			featured && 'md:grid md:grid-cols-[minmax(0,1.35fr)_minmax(0,1fr)]',
		),
		media: cn(
			'min-w-0 aspect-[16/9] overflow-hidden border-b bg-surface',
			featured && 'md:aspect-auto md:h-full md:border-b-0 md:border-r',
		),
		content: cn('flex-column min-w-0 p-5 md:p-6', featured && 'md:min-h-80'),
		title: cn('type-section-title mt-4 text-balance', featured && 'md:text-3xl'),
	};

	// Render
	return (
		<NextLink href={`${rootLink}/${article.tag.uuid}/${article.uuid}`} className={classNames.root}>
			<div className={classNames.media}>
				<img
					src={article.cover}
					alt=''
					className='h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.02]'
				/>
			</div>
			<div className={classNames.content}>
				<div className='flex-start gap-2 font-mono text-[11px] uppercase tracking-[0.14em] text-foreground-subtle'>
					<span>{article.tag.name}</span>
					<span aria-hidden>•</span>
					<time>{formatDate(article.publishDate, 'MMM D, YYYY')}</time>
				</div>
				<h2 className={classNames.title}>{article.title}</h2>
				<p className='mt-3 line-clamp-3 text-sm leading-6 text-foreground-body'>{article.description}</p>
				<div className='mt-auto flex-between-bottom gap-4 pt-8'>
					<OwnerAvatar layout='meta' owner={article.owner} />
					<Icon
						data-icon='inline-end'
						type='far'
						icon='arrow-up-right'
						className='shrink-0 text-foreground-body transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-foreground'
						aria-hidden
					/>
				</div>
			</div>
		</NextLink>
	);
};

const BlogListCard = props => <BlogGridCard {...props} />;

export { BlogGridCard, BlogListCard };
